import * as React from 'react';
import { useTranslations } from '../../../common/translation';
import { Button } from '../../../components/button/Button';
import translations from '../translations';
import { PromoBanner } from './PromoBanner';
import {
  StyledPBContentHeader,
  StyledPBContentLink,
  StyledPBContentSubtitle,
  StyledPBContentSupertitle,
  StyledPBContentText,
  StyledPBContentTitle,
} from './PromoBanner.styles';

const websiteUrl = 'http://www.harrypotterplatform934.com';

export const Platform934Banner = () => {
  const { t } = useTranslations(translations);
  const subtitle = t('platform934Subtitle');

  return (
    <PromoBanner
      backgroundSrc='/assets/experiences/shop/platform-banner.jpg'
      imageAlt='Platform 9 ¾'
      imageSrc='/assets/experiences/shop/platform-shop-items.png'
      isImageWide={true}
      testId='platform934-banner'
    >
      <StyledPBContentHeader>
        <StyledPBContentLink href={websiteUrl} target='_blank'>
          <StyledPBContentSupertitle>
            {t('platform934Supertitle', 'The Harry Potter Shop at')}
          </StyledPBContentSupertitle>
          <StyledPBContentTitle>{t('platform934Title', 'Platform 9 ¾')}</StyledPBContentTitle>
          {subtitle && <StyledPBContentSubtitle>{subtitle}</StyledPBContentSubtitle>}
        </StyledPBContentLink>
      </StyledPBContentHeader>
      <StyledPBContentText>
        {t(
          'platform934Text',
          // tslint:disable-next-line:max-line-length
          'A one of a kind shopping experience for fans of the Wizarding World. Visit the famous trolley at Platform 9 3/4, Kings Cross Station.',
        )}
      </StyledPBContentText>
      <Button disableCaps={true} href={websiteUrl} target='_blank'>
        {t('platform934ButtonText', 'Shop Online Now')}
      </Button>
    </PromoBanner>
  );
};
